        
import {
  LinkedinShareButton,
  LinkedinIcon,
  RedditShareButton,
  RedditIcon,
  PinterestShareButton,
  PinterestIcon,
  WhatsappIcon,
  WhatsappShareButton,
  TwitterIcon,
  TwitterShareButton,
  FacebookIcon,
  FacebookShareButton,
  EmailShareButton,
  EmailIcon,
} from 'next-share';
import { ref, set, push} from "firebase/database";
import { database } from '../firebase/firebaseApp';
import { Link } from "lucide-react";

const Share = ({url, post}) => {   
  //needs fixing  
  function UpdateDatabase(platform){
    console.log("post.IDDDD", post)
    if(platform !== "" && post.postID != "") {
      const newShare = push(ref(database, `/blog/${post.postID}/shared`));
      set(newShare,
        {
          "platform_shared":  platform,
          "shared_date" : new Date().toLocaleDateString(),
        });
    }
  }

  // 📋 copy link function
  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(`${url}${post.slug}`);
      UpdateDatabase("Copy Link")
    } catch (err) {
      console.error("Failed to copy: ", err);
    }
  };

  const iconProps = {
    size: 30,
    iconFillColor: "#000", // black icon
    bgStyle: { 
      fill: "#fff",           // white background
    },
  };

  return (
    <div className="px-5 mt-20">
      <div className="flex flex-row items-center justify-start space-x-1 pl-3">
        <button 
          onClick={copyToClipboard} 
          className="flex items-center justify-center pb-2 transition"
        >
          <Link className="w-5 h-5 text-black" />
        </button>
        <div onClick={() => UpdateDatabase("Linkedin")}>
          <LinkedinShareButton url={`${url}${post.slug}`}>
            <LinkedinIcon {...iconProps} />
          </LinkedinShareButton>
        </div>
        <div onClick={() => UpdateDatabase("Reddit")}>
          <RedditShareButton  url={`${url}${post.slug}`} title={post.title}>
            <RedditIcon {...iconProps} />
          </RedditShareButton>
        </div>
        <div onClick={() => UpdateDatabase("Facebook")}>
          <FacebookShareButton url={`${url}${post.slug}`} hashtag="Monet Art">
            <FacebookIcon {...iconProps} />
          </FacebookShareButton>
        </div>
        <div onClick={() => UpdateDatabase("Twitter")}>
          <TwitterShareButton url={`${url}${post.slug}`} title={post.title} via="Monet_LLC" hashtags={post.categories.map((cat) => cat.name)}>
            <TwitterIcon {...iconProps} />
          </TwitterShareButton>
        </div>
        <div onClick={() => UpdateDatabase("Pinterest")}>
          <PinterestShareButton url={`${url}${post.slug}`} media={post.featuredImage[0].url}>
            <PinterestIcon {...iconProps} />
          </PinterestShareButton>
        </div>
        <div onClick={() => UpdateDatabase("Whastapp")}>
          <WhatsappShareButton title={post.title} url={`${url}${post.slug}`}>
            <WhatsappIcon {...iconProps} size={27}/>
          </WhatsappShareButton >
        </div>
        <div onClick={() => UpdateDatabase("Email")}>
          <EmailShareButton url={`https://${url}${post.slug}`} subject={post.title} body={post.excerpt}>
            <EmailIcon {...iconProps} />
          </EmailShareButton>
        </div>
      </div>
    </div>
  );
}

export default Share;